<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { Alert, AlertTitle, AlertDescription } from '@/components/shadcn'
import { JButton } from '@/components/atoms'
import { cn } from "@/lib/utils"

const props = withDefaults(
  defineProps<{
    /** Alert 자체의 클래스 */
    class?: HTMLAttributes["class"]
    /** Alert variant 스타일 */
    variant?: "default" | "destructive"
    /** Alert 제목 (Header) */
    title?: string
    /** Alert 설명/내용 (Body) */
    description?: string
    /** Footer에 표시할 버튼 텍스트 */
    buttonText?: string
    /** Footer 버튼 클릭 핸들러 */
    onConfirm?: () => void
    /** Footer 표시 여부 */
    showFooter?: boolean
  }>(),
  {
    variant: "default",
    showFooter: true,
    buttonText: "확인"
  }
)

const emit = defineEmits<{
  confirm: []
}>()

const handleConfirm = () => {
  props.onConfirm?.()
  emit('confirm')
}
</script>

<template>
  <Alert :variant="props.variant" :class="cn(props.class)">
    <!-- Header -->
    <AlertTitle v-if="title">
      <slot name="header">{{ title }}</slot>
    </AlertTitle>
    
    <!-- Body -->
    <AlertDescription>
      <slot>{{ description }}</slot>
    </AlertDescription>
    
    <!-- Footer -->
    <div v-if="showFooter" class="mt-4 flex justify-end gap-2">
      <slot name="footer">
        <JButton 
          :variant="variant === 'destructive' ? 'secondary' : 'default'"
          size="sm"
          @click="handleConfirm"
        >
          {{ buttonText }}
        </JButton>
      </slot>
    </div>
  </Alert>
</template>
